import { useEffect } from "react"
import Contacts from "react-native-contacts"
import { requestContactPermissions } from "./permissions"

export const deviceContacts = {
  async addContact(contact: { name: string; number: string }) {
    const granted = await requestContactPermissions()
    if (!granted) return

    return await Contacts.addContact({
      recordID: "",
      displayName: contact.name,
      note: "",
      backTitle: "",
      company: "",
      emailAddresses: [],
      familyName: "",
      givenName: contact.name,
      middleName: "",
      jobTitle: "",
      phoneNumbers: [
        {
          label: "phone",
          number: contact.number,
        },
      ],
      hasThumbnail: false,
      thumbnailPath: "",
      postalAddresses: [],
      prefix: "",
      suffix: "",
      department: "",
      birthday: {} as any,
      imAddresses: [],
    })
  },
  async getContactByPhoneNumber(number: string) {
    const granted = await requestContactPermissions()
    if (!granted) return []

    return await Contacts.getContactsByPhoneNumber(number)
  },
}

function useDeviceContacts() {
  useEffect(() => {
    // Get permissions when the hook is first used to prevent akward permission asking at later crucial times
    requestContactPermissions()
  }, [])

  return deviceContacts
}

export default useDeviceContacts
